import { isEmpty } from 'lodash-es';
import React, { useState } from 'react';

import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { IDNameTableModal } from '~/src/dash/components/modals/IDNameTableModal';
import { IItemIDNameRoute } from '~/src/dash/components/tables/IDNameTable/common';
import { Col, Cols, Div, spacing, Text } from '~/src/dash/publicaUI';
import { ItemRouteType } from '~/src/dash/router/routes';
import { publicaColors } from '~/src/dash/utils/colors';

const generateTitle = (numItems: number, singularLabel: string, pluralLabel: string) => {
  return `${numItems} ${numItems === 1 ? singularLabel : pluralLabel}`;
};

interface IProps {
  items: IItemIDNameRoute[];
  singularLabel: string;
  pluralLabel: ItemRouteType;
  color: string;
  iconName: string;
  modalTitle: string;
  modalSubTitle: string;
}

export const TargetingPresetAssociatedBadge = ({
  items,
  singularLabel,
  pluralLabel,
  color,
  iconName,
  modalTitle,
  modalSubTitle,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const isItemsEmpty = isEmpty(items);
  const numItems = isItemsEmpty ? 0 : items.length;

  return (
    <>
      {/* BADGE */}
      <Div
        onClick={() => setIsOpen(true)}
        style={{ cursor: !isItemsEmpty ? 'pointer' : 'default' }}
      >
        <Cols gap={spacing.small} style={{ alignItems: 'center' }}>
          <Col
            style={{
              border: `1px solid ${publicaColors.veryDarkGray}`,
              borderRadius: '4px',
              backgroundColor: color,
              padding: `2px 8px`,
            }}
          >
            <Cols gap={spacing.small} style={{ alignItems: 'center' }}>
              <Col displayFlex>
                <IconV2 name={iconName} small />
              </Col>
              <Col>
                <Text small bold style={{ whiteSpace: 'nowrap' }}>
                  {generateTitle(numItems, singularLabel, pluralLabel)}
                </Text>
              </Col>
            </Cols>
          </Col>
        </Cols>
      </Div>
      {/* MODAL */}
      {!isItemsEmpty && (
        <IDNameTableModal
          open={isOpen}
          onClose={() => setIsOpen(false)}
          title={modalTitle}
          subTitle={modalSubTitle}
          data={items || []}
          type={pluralLabel}
        />
      )}
    </>
  );
};
